import { mapAsyncActions } from './utils/async-actions-helper';
import { asyncActions as expensesAsyncActions } from '../reducer/expenses';

export const initialState = {
  items: [],
  bills: [],
  count: 0,
  sum: 0,
  filterExpenseIDs: [],
  page: 0,
  loading: false,
  saving: false,
  requestId: null,
};
export { actions as reducers } from '../reducer/expenses';
export const { asyncActions, extraReducers } = mapAsyncActions(
  'expenses',
  expensesAsyncActions,
);
